import React, {
  ComponentType,
  FC,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import {
  SelectionsProps,
  IsSelectable,
  ColumnsProps,
} from 'components/atoms/grid';
import { editableWhen } from './editable-when';

export const withCreatingTasks = <T extends SelectionsProps & ColumnsProps>(
  Component: ComponentType<T>,
): FC<T> => {
  const Next: FC<T> = ({ isSelectable: original, columns, ...props }) => {
    const isSelectableRef = useRef<IsSelectable | null>(original ?? null);

    useEffect(() => {
      isSelectableRef.current = original ?? null;
    }, [isSelectableRef, original]);

    const isSelectable = useCallback(
      (id: string) => {
        return !id?.startsWith('-') && (isSelectableRef.current?.(id) ?? true);
      },
      [isSelectableRef],
    );
    const disallowEditingWhileCreating = editableWhen(
      ({ node }) => !node?.id?.startsWith('-'),
    );

    return (
      <Component
        {...(props as any)}
        isSelectable={isSelectable}
        columns={columns.map(disallowEditingWhileCreating)}
      />
    );
  };

  return setDisplayName(wrapDisplayName(Component, 'WithCreatingTasks'))(Next);
};
